export default {
  isEmpty (value) {
    if (value === null || value === undefined) {
      return true
    }
    if (value.prop && value.prop.constructor === Array) {
      return value.length === 0
    } else if (typeof value === 'object') {
      return Object.keys(value).length === 0 && value.constructor === Object
    } else if (typeof value === 'string') {
      return value.length === 0
    } else if (typeof value === 'number') {
      return value === 0
    } else if (!value) {
      return true
    }
    return false
  },
  getJson (url, method, body, callback) {
    fetch(url, {
      method: method,
      body: body
    }).then(function (response) {
      console.log(response.headers.get('content-type'))

      var contentType = response.headers.get('content-type')
      response.json().then(function (json) {
        if (contentType && contentType.indexOf('application/json') !== -1) {
          
            callback(json)
         
        } else {
          console.log('Oops, we haven not got JSON!')
        }
      })
    })
  },
  getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  },
  getRandomInt(min, max) { 
    return Math.floor(Math.random() * (max - min)) + min;
  }
}
